// components/templates/sections/Marquee.tsx
'use client';
import React from 'react';
import { useDesign } from '@/context/DesignContext';

interface MarqueeProps {
  items?: string[];
  design?: any;
}

export default function Marquee({ items, design: propDesign }: MarqueeProps) {
  const contextDesign = useDesign();
  const design = propDesign || contextDesign;

  if (!items || items.length === 0) return null;

  const primaryColor = design?.colors?.primary || '#C8A96E';
  const textLightColor = design?.colors?.textLight || '#A3A3A3';
  const bodyFont = design?.typography?.bodyFont || "'Inter', sans-serif";

  return (
    <div className="overflow-hidden py-5 border-y" style={{ borderColor: `${primaryColor}26`, background: `${primaryColor}08` }}>
      <div className="marquee-track">
        {[...Array(2)].map((_, i) => (
          <div key={i} className="flex items-center gap-12 pr-12">
            {items.map((t) => (
              <span key={t} className="flex items-center gap-12 text-xs uppercase tracking-widest font-light whitespace-nowrap" style={{ fontFamily: bodyFont, color: textLightColor }}>
                {t}
                <span style={{ color: primaryColor }}>✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}